import { useEffect, useRef, ReactNode } from "react";
import { useAuth } from "@context/AuthContext";
import { authEnabledInstances } from "@api/instances";
import { applyAuthToInstances } from "@api/interceptorManager";

interface AuthInterceptorProviderProps {
  children: ReactNode;
}

export const AuthInterceptorProvider = ({ children }: AuthInterceptorProviderProps) => {
  const { token, isAuthLoading, refreshAction, logout } = useAuth();

  const tokenRef = useRef(token);
  tokenRef.current = token;

  useEffect(() => {
    return applyAuthToInstances(
      authEnabledInstances,
      () => tokenRef.current,
      refreshAction,
      logout,
    );
  }, [refreshAction, logout]);

  // Block the child tree from mounting until the initial token fetch has
  // settled. This guarantees that no data context fires an API call before
  // tokenRef.current has been populated, eliminating the race condition.
  if (isAuthLoading) return null;

  return <>{children}</>;
};
